import React from 'react';
import { ClockIcon, HelpCircleIcon, PuzzleIcon, RefreshCwIcon, RouteIcon, WrenchIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { painPoints } from '../../data/content';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  help: HelpCircleIcon,
  clock: ClockIcon,
  route: RouteIcon,
  wrench: WrenchIcon,
  refresh: RefreshCwIcon,
  puzzle: PuzzleIcon
};
export function PainPoints() {
  return <section className="bg-cream px-5 py-16 sm:py-20" data-id="element-212" data-mp="2hmkw6qa45twf">
      <div className="mx-auto max-w-4xl" data-id="element-213" data-mp="2ckc4rycw2zwf">
        <h2 className="text-center font-serif text-[30px] leading-tight sm:text-5xl font-extrabold text-ink" data-id="element-214" data-mp="2cnhw7k8zqdvb">
          Do any of these sound familiar?
        </h2>
        <p className="mt-4 text-center text-[17px] text-muted" data-id="element-215" data-mp="2mkw774c5aag8">
          If you answer <strong className="text-brand-700" data-id="element-216" data-mp="w6dlgt26cu8f">YES</strong> to even one, I created this system for you.
        </p>

        <ul className="mt-10 divide-y divide-brand-100 rounded-3xl bg-white px-5 sm:px-8 shadow-[0_20px_50px_-30px_rgba(38,16,64,0.35)]" data-id="element-217" data-mp="s6lh6sjtda8v">
          {painPoints.map(p => {
          const Icon = icons[p.icon];
          return <li key={p.text} className="flex gap-4 py-5" data-id="element-218" data-mp="1s4tosam3q5zk">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-100 text-brand-700" data-id="element-219" data-mp="1x57pf7ldidnk">
                  <Icon className="h-5 w-5" data-id="element-220" data-mp="21y0y26jyq64x" />
                </span>
                <p className="text-[16px] sm:text-lg leading-snug text-ink" data-id="element-221" data-mp="26urckpg4cto8">{p.text}</p>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-222" data-mp="2az8s2cfg4kt7">
          <p className="font-serif text-2xl sm:text-3xl font-bold text-ink" data-id="element-223" data-mp="2fxsesf1v60mm">And it shouldn’t feel this complicated.</p>
          <p className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-224" data-mp="2kuskgousx1d7">
            The problem isn’t that you need more information. You need a{' '}
            <strong className="text-ink" data-id="element-225" data-mp="qh1476hyvj8s">better way to organize the information you already have.</strong> That’s why I built
            the Ortho Decision System™.
          </p>
        </div>

        <div className="mt-10" data-id="element-226" data-mp="efrotywmxxte">
          <CtaButton label="Give me the system" data-id="element-227" data-mp="egkxx6j2gzep" />
        </div>
      </div>
    </section>;
}